export const storageService = {
  getItem(key: string): string | null {
    try {
      const storage = typeof window !== 'undefined'
        ? window.localStorage
        : (globalThis as { localStorage?: Storage }).localStorage;
      return storage ? storage.getItem(key) : null;
    } catch {
      return null;
    }
  },

  setItem(key: string, value: string): void {
    try {
      const storage = typeof window !== 'undefined'
        ? window.localStorage
        : (globalThis as { localStorage?: Storage }).localStorage;
      if (!storage) return;
      storage.setItem(key, value);
    } catch {
      // ignore storage errors
    }
  },

  removeItem(key: string): void {
    try {
      const storage = typeof window !== 'undefined'
        ? window.localStorage
        : (globalThis as { localStorage?: Storage }).localStorage;
      if (!storage) return;
      storage.removeItem(key);
    } catch {
      // ignore storage errors
    }
  }
};
